(() => {
  function init() {
    const button = document.querySelector('.hv-menu-toggle');
    const nav = document.getElementById('hv-navigation');
    if (button && nav && !button.dataset.ready) {
      button.dataset.ready = 'true';
      const mobile = matchMedia('(max-width:749px)');
      let bodyOverflow, htmlOverflow;
      function close() {
        button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-label', 'Open menu');
        nav.classList.remove('is-open');
        if (bodyOverflow !== undefined) {
          document.body.style.overflow = bodyOverflow;
          document.documentElement.style.overflow = htmlOverflow;
          bodyOverflow = undefined;
        }
      }
      button.addEventListener('click', () => {
        if (button.getAttribute('aria-expanded') === 'true') { close(); return; }
        button.setAttribute('aria-expanded', 'true');
        button.setAttribute('aria-label', 'Close menu');
        nav.classList.add('is-open');
        if (mobile.matches) {
          bodyOverflow = document.body.style.overflow;
          htmlOverflow = document.documentElement.style.overflow;
          document.body.style.overflow = 'hidden';
          document.documentElement.style.overflow = 'hidden';
          nav.querySelector('a')?.focus();
        }
      });
      nav.addEventListener('click', event => { if (event.target.closest('a')) close(); });
      document.addEventListener('click', event => {
        if (!event.target.closest('.hv-header')) close();
      });
      document.addEventListener('keydown', event => {
        if (!nav.classList.contains('is-open')) return;
        if (event.key === 'Escape') { close(); button.focus(); }
        if (event.key === 'Tab' && mobile.matches) {
          const stops = [button, ...nav.querySelectorAll('a[href]')].filter(element => element.getClientRects().length > 0);
          if (event.shiftKey && document.activeElement === stops[0]) { event.preventDefault(); stops.at(-1).focus(); }
          else if (!event.shiftKey && document.activeElement === stops.at(-1)) { event.preventDefault(); stops[0].focus(); }
        }
      });
      mobile.addEventListener('change', close);
    }
    const group = document.querySelector('.tp-breadcrumbs a[href*="/collections/"]');
    nav?.querySelectorAll('a[href]').forEach(link => {
      const path = new URL(link.href).pathname;
      const current = path === location.pathname || (location.pathname.startsWith('/products/') && group && path === new URL(group.href).pathname);
      if (current) link.setAttribute('aria-current', 'page'); else link.removeAttribute('aria-current');
    });
    document.querySelectorAll('[data-hv-tabs]').forEach(group => {
      if (group.dataset.ready) return;
      group.dataset.ready = 'true';
      const tabs = [...group.querySelectorAll('[role=tab]')];
      const select = tab => tabs.forEach(other => {
        const selected = other === tab;
        other.setAttribute('aria-selected', String(selected));
        other.tabIndex = selected ? 0 : -1;
        const panel = document.getElementById(other.getAttribute('aria-controls'));
        if (panel) panel.hidden = !selected;
      });
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); select(tabs[next]); tabs[next].focus(); }
        });
      });
    });
  }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  init();
})();

// Default to Catalog; use an anchor only when its section is actually rendered and visible.
(()=>{
  let observer;
  function sync(){
    const section=document.getElementById('needs');
    const visible=section&&!section.hidden&&section.getClientRects().length>0&&getComputedStyle(section).visibility!=='hidden';
    document.querySelectorAll('[data-hv-needs-link]').forEach(link=>{
      link.setAttribute('href',visible?'#needs':link.dataset.hvFallback);
    });
  }
  function init(){
    sync();
    if(window.Shopify?.designMode&&document.body&&!observer){
      observer=new MutationObserver(sync);
      observer.observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['hidden','style']});
    }
  }
  document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:unload',()=>queueMicrotask(init));
  document.addEventListener('click',event=>{if(event.target.closest('[data-hv-needs-link]'))sync();},true);
  init();
})();

// Fit the actual loaded font, keeping desktop headings within three lines.
(()=>{
  let frame;
  function fit(){
    document.querySelectorAll('.hv-fullscreen-inner h1').forEach(heading=>{
      heading.classList.remove('hv-heading-compact');
      if(!matchMedia('(min-width:1001px)').matches)return;
      const lineHeight=parseFloat(getComputedStyle(heading).lineHeight);
      if(heading.getBoundingClientRect().height>lineHeight*3+1)heading.classList.add('hv-heading-compact');
    });
  }
  function schedule(){cancelAnimationFrame(frame);frame=requestAnimationFrame(fit);}
  document.addEventListener('DOMContentLoaded',schedule);
  document.addEventListener('shopify:section:load',schedule);
  window.addEventListener('resize',schedule);
  document.fonts.ready.then(schedule);
  schedule();
})();
